import type { PersonProfile } from '@openeducation/oe-rn-shared-types';
import { atom } from 'jotai';

export const teacherProfileAtom = atom<PersonProfile | null>(null);

export const teacherIdAtom = atom<number | undefined>(
  (get) => get(teacherProfileAtom)?.id
);
